module.exports = __webpack_public_path__ + "static/media/21-12.f8fec700.mp3";